import { Button, Chip, Paper, Typography } from "@mui/material";
import { Box, Grid, Stack } from "@mui/system";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import { Link, useLocation } from "react-router-dom";
import LinkIcon from "@mui/icons-material/Link";
import AllLinkedLandingPagesModal from "./LPKeywordModal/AllLinkedLandingPagesModal";
import KeywordsLinkedURLModal from "./LPKeywordModal/KeywordsLinkedURLModal";
import { useState } from "react";
import { useSelector } from "react-redux";
import DateRangeParamPicker from "./DateRangeParamPickerLP";
import { useFetchKeywordDetails } from "../../../../../pages/PaidTrafficManagement/hooks/useFetchKeywordDetails";
import { selectUserWebsitePermissions } from "../../../../../features/userSlice";

// Linked Table date
const LinkedTableHeadings = {
  page_url: "URL",
  clicks: "Clicks",
  cost: "Cost",
  impressions: "IMP",
  conversions: "CVR",
};

// Keywords Table date
const KeywordsTableHeadings = {
  keyword_name: "KeyWord",
  matchtype: "Match Type",
  adgroup_name: "Ad Group",
  campaign_name: "Campaign",
  cost: "Cost",
  lp_exp_score_weight: "LP EXP",
  quality_score: "QS",
  // relevance: "Relevance",
};

const SingleLandingPageGetData = () => {
  const {
    fetchKeywordDetails,
    fetchSingleKeywordDetails,
    fetchDailyLPExperienceDetails,
    fetchCompetitorMetricsAccordion,
    fetchKeywordsLinkedToURL,
  } = useFetchKeywordDetails();
  const [openLinkedLandingPagesModal, setOpenLinkedLandingPagesModal] =
    useState(false);
  const [openKeywordsLinkedModal, setOpenKeywordsLinkedModal] = useState(false);
  const { keywordDetailsByInternalId, urlKeywordsLoading } = useSelector(
    (state: any) => state.landingPageExperience
  );
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const allWebsites = useSelector(selectUserWebsitePermissions);

  const selectedSite = searchParams.get("selectedSite") as any;

  const matchedWebsite = allWebsites?.find(
    (site: any) => Object.keys(site)[0] === selectedSite
  );

  const matchedUrl = matchedWebsite
    ? matchedWebsite[selectedSite]?.site_url?.replace(/\/$/, "")
    : null;

  const handleOpenLinkedLandingPagesModal = () => {
    setOpenLinkedLandingPagesModal(true);
  };

  const handleCloseModal = () => {
    setOpenLinkedLandingPagesModal(false);
    setOpenKeywordsLinkedModal(false);
  };
  const { singleKeywordDetails } = useSelector(
    (state: any) => state.landingPageExperience
  );

  const rowWithMaxClicks = keywordDetailsByInternalId.reduce(
    (maxRow: any, currentRow: any) => {
      return currentRow.clicks > (maxRow?.clicks ?? -Infinity)
        ? currentRow
        : maxRow;
    },
    null
  );

  const landingPageShareUid = rowWithMaxClicks?.page_shared_uid;
  const handleKeywordsLinkedModal = async () => {
    await fetchKeywordsLinkedToURL(landingPageShareUid);
    setOpenKeywordsLinkedModal(true);
  };

  const handleFetchKeywordDetails = () => {
    fetchKeywordDetails();
    fetchSingleKeywordDetails();
    fetchDailyLPExperienceDetails();
    fetchCompetitorMetricsAccordion();
  };

  const {
    adgroup_id,
    adgroup_name,
    campaign_name,
    cost,
    keyword_name,
    matchtype,
  } = singleKeywordDetails?.[0] || {};

  return (
    <>
      <Paper sx={{ padding: "16px", mb: 2 }}>
        <Grid container mt={0} columnSpacing={2}>
          <Grid size={10}>
            <Stack flexDirection={"row"} alignItems={"center"}>
              <Typography fontSize={24}>{keyword_name}</Typography>
              <Chip
                label={matchtype}
                color="secondary"
                sx={{ height: "30px", mx: "16px" }}
              />
              <Button
                endIcon={<LayersOutlinedIcon />}
                color="secondary"
                variant="outlined"
                size="small"
                onClick={handleOpenLinkedLandingPagesModal}
              >
                <span style={{ textDecoration: "underline" }}>
                  {" "}
                  all linked Landing Pages
                </span>
              </Button>
            </Stack>

            <Stack flexDirection={"row"} alignItems={"center"} mb={0.5}>
              <Typography fontSize={14}>
                <strong style={{ fontWeight: "500" }}>Adgroup Name:</strong>{" "}
                {adgroup_name}
              </Typography>
              <Typography fontSize={14} mx={2}>
                <strong style={{ fontWeight: "500" }}>Adgroup ID : </strong>
                {adgroup_id}
              </Typography>
              <Typography fontSize={14}>
                <strong style={{ fontWeight: "500" }}>Campaign Name : </strong>
                {campaign_name}
              </Typography>
            </Stack>

            <Stack flexDirection={"row"} alignItems={"flex-end"}>
              <Typography fontSize={16}>
                <span style={{ fontSize: "12px", display: "block" }}>Cost</span>
                {(() => {
                  const numericCost = parseFloat(cost);
                  return isNaN(numericCost)
                    ? ""
                    : `${Math.round(numericCost).toLocaleString()}$`;
                })()}
              </Typography>

              <Typography fontSize={16} mx={2}>
                <span style={{ fontSize: "12px", display: "block" }}>
                  Landing Page
                </span>

                {rowWithMaxClicks?.page_url ? (
                  <Link
                    style={{ color: "#9C27B0" }}
                    to={`${matchedUrl}${rowWithMaxClicks.page_url}`}
                    target="_blank"
                  >
                    {`${matchedUrl}${rowWithMaxClicks.page_url}`}
                  </Link>
                ) : (
                  <span style={{ color: "gray" }}>
                    No landing page available
                  </span>
                )}
              </Typography>

              <Button
                endIcon={<LinkIcon />}
                color="secondary"
                variant="outlined"
                size="small"
                onClick={handleKeywordsLinkedModal}
                loading={urlKeywordsLoading}
              >
                <span style={{ textDecoration: "underline" }}>
                  {" "}
                  Keywords linked to this URL
                </span>
              </Button>
            </Stack>
          </Grid>
          <Grid size={2}>
            <Stack sx={{ mb: "20px" }}>
              <DateRangeParamPicker />
            </Stack>
            <Box justifyContent={"end"} display={"flex"}>
              <Button
                variant="contained"
                //disabled
                size="large"
                color="secondary"
                sx={{ whiteSpace: "nowrap", width: "116px" }}
                onClick={() => {
                  handleFetchKeywordDetails();
                }}
                data-tracker="474"
              >
                Get Data
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      <AllLinkedLandingPagesModal
        open={openLinkedLandingPagesModal}
        handleClose={handleCloseModal}
        LinkedTableHeadings={LinkedTableHeadings}
        LinkedRows={keywordDetailsByInternalId}
      />
      <KeywordsLinkedURLModal
        open={openKeywordsLinkedModal}
        handleClose={handleCloseModal}
        KeywordsTableHeadings={KeywordsTableHeadings}
      />
    </>
  );
};

export default SingleLandingPageGetData;
